import { Controller } from "stimulus"

// Chooses which tutorial video to show. Sources are rendered by PortalTutorialHelper;
// the video has no src until the user picks a situation, so nothing is downloaded before that.
export default class extends Controller {
  static targets = ["option", "video", "error"]
  // locale is the language of the video file that plays (zh-CN users get zh-TW), used to tag tracking events
  static values = { sources: Object, locale: String }

  select(event) {
    const button = event.currentTarget
    const flow = button.dataset.flow
    const src = this.sourcesValue[flow]
    if (!src) return
    // Picking the same situation again must not restart a video that is already showing
    if (this.flow === flow && !this.videoTarget.classList.contains("hidden")) return

    this.flow = flow
    this.playTracked = false
    this.completeTracked = false
    this.optionTargets.forEach((option) => option.setAttribute("aria-pressed", String(option === button)))
    this.errorTarget.classList.add("hidden")
    this.videoTarget.setAttribute("aria-label", button.textContent.trim())
    // #t=0.001 makes iOS Safari draw the first frame instead of an empty box
    this.videoTarget.src = `${src}#t=0.001`
    this.videoTarget.classList.remove("hidden")
    this.videoTarget.load()
    this.track("select")
  }

  // Closing the section must not leave audio playing behind it
  toggled() {
    if (!this.element.open) this.videoTarget.pause()
  }

  // The files are uploaded by hand, so a missing one should say so instead of leaving a black box
  failed() {
    this.videoTarget.classList.add("hidden")
    this.errorTarget.classList.remove("hidden")
  }

  played() {
    if (this.playTracked) return
    this.playTracked = true
    this.track("play")
  }

  ended() {
    if (this.completeTracked) return
    this.completeTracked = true
    this.track("complete")
  }

  track(action) {
    if (!window.trackingEvent) return
    window.trackingEvent.track_module_click({
      page_type: "portal_entry",
      module: "tutorial_video",
      landing_path: window.location.pathname,
      target_type: "video",
      target_id: `${this.flow}-${this.localeValue}`,
      action,
    })
  }
}
